// Concept card — Phase G1.
import { createFileRoute } from "@tanstack/react-router";
import { lazy } from "react";
import { useAppState } from "../App/AppStateContext.tsx";
import { Loading } from "../App/Loading.jsx";

const ConceptCardScreen = lazy(
  () => import("../components/ConceptCardScreen.tsx"),
);

function ConceptRoute() {
  const s = useAppState();
  if (!s.pendingConcept) return <Loading />;
  return (
    <ConceptCardScreen
      card={s.pendingConcept.card}
      onStart={s.handleConceptAcknowledged}
      onCancel={() => {
        s.setPendingConcept(null);
        s.setActiveSession(null);
        s.setScreen("home");
      }}
    />
  );
}

export const Route = createFileRoute("/concept")({
  component: ConceptRoute,
});
